import { useEffect } from 'react'
import { isNamePath } from './lib/route'
import HomePage from './pages/HomePage'
import NamePage from './pages/NamePage'

const APP_URL = 'https://app.myofade.com'
const HOME_TITLE = 'MyoFade - Muscle recovery heatmap for the gym'

export default function App() {
  const onName = isNamePath(window.location.pathname)

  useEffect(() => {
    if (!onName) {
      document.title = HOME_TITLE
    }
  }, [onName])

  return (
    <div className="site">
      <a className="skip-link" href="#main">
        Skip to content
      </a>

      <header className="nav" role="banner">
        <a className="nav-brand" href="/">
          <img src="/logos/icon.svg" width={36} height={36} alt="" />
          <span>MyoFade</span>
        </a>
        <a className="nav-cta" href={APP_URL}>
          Open app
        </a>
      </header>

      {onName ? <NamePage /> : <HomePage />}

      <footer className="site-footer">
        <p>© {new Date().getFullYear()} MyoFade · myofade.com</p>
        <p>
          <a href="/name">The name</a>
          {' · '}
          <a href={APP_URL}>Web app</a>
          {' · '}
          <a href="/robots.txt">Robots</a>
          {' · '}
          <a href="/sitemap.xml">Sitemap</a>
        </p>
      </footer>
    </div>
  )
}
